import { render, staticRenderFns } from "./chateau-palmer.vue?vue&type=template&id=49cf93ee&scoped=true"
import script from "./chateau-palmer.vue?vue&type=script&lang=js"
export * from "./chateau-palmer.vue?vue&type=script&lang=js"
import style0 from "./chateau-palmer.vue?vue&type=style&index=0&id=49cf93ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49cf93ee",
  null
  
)

export default component.exports